import { NavLink, withRouter } from 'react-router-dom'
import React from 'react'
import { TableVirtualized } from '../root/components/common/table-virtualized/table'
import { useSelector } from 'react-redux'
import { makeStyles, Typography } from '@material-ui/core'
import classNames from 'classnames'
import { getFormattedDate } from '../../utils'

const useStyles = makeStyles(theme => ({
    nameLink: {
        ...theme.link
    }
}))

const DevicesApiBillingTableComponent = ({ data }) => {
    const { locale } = useSelector(state => state.main)

    const classes = useStyles()

    const Link = prop => <NavLink target={'_blank'} {...prop} />

    const handleLinkClick = e => {
        e.stopPropagation()
    }

    const columns = [
        {
            key: 'serial_number',
            label: locale.devices.serialNr,
            sortable: false,
            dataType: 'string',
            width: 1.5,
            minWidth: 140,
            render: ({ rowData, cellData }) => {
                return (
                    <Typography noWrap variant="inherit">
                        <Link
                            onClick={handleLinkClick}
                            className={classNames(classes.nameLink)}
                            to={`/devices/${rowData.id}`}
                        >
                            {rowData.serial_number}
                        </Link>
                    </Typography>
                )
            }
        },
        {
            key: 'last_heartbeat',
            label: locale.billing.lastHeartbeat,
            sortable: false,
            dataType: 'date',
            width: 1,
            render: ({ rowData }) => getFormattedDate(rowData.last_heartbeat)
        }
    ]

    const navigateToDevice = rowObj => {
        window.open(`/devices/${rowObj.rowData.id}`, '_blank')
    }

    return (
        <TableVirtualized
            data={data}
            columns={columns}
            onRowClick={navigateToDevice}
        />
    )
}

const DevicesApiBillingTable = withRouter(DevicesApiBillingTableComponent)
export { DevicesApiBillingTable }
